/**
 * Sort an array of objects by a property value
 *
 * @param {*} array | array of objects
 * @param {*} string | object property name
 */
export default function(array, property) {
    return array.sort(function(a, b) {
        if (a[property] < b[property]) return -1;
        if (a[property] > b[property]) return 1;
        return 0;
    });
}



// WEBPACK FOOTER //
// ./src/js/utilities/sort-by-prop.js